import type { Method } from 'lib/axios';
import { APICallV4 } from 'reactApp/api/APICall';

export class OverquotaUnblockAPICall extends APICallV4 {
    _method = 'overquota/unblock';
    _type: Method = 'post';
}
